<template>
	<div class="MAM_queryList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-date-picker
					    v-model="rangeDate"
					    type="daterange"
					    range-separator="至"
					    start-placeholder="提现开始时间"
					    end-placeholder="提现结束时间"
					    value-format="yyyy-MM-dd"
					    @change="pickerChange"
					></el-date-picker>
					<!-- <el-date-picker type="date" placeholder="提现开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
					-
					<el-date-picker type="date" placeholder="提现结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker> -->
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.account_name" placeholder="请输入提现发起人"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.mobile" placeholder="请输入销售账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.status" clearable placeholder="付款状态">
						<el-option label="出款成功" value="2"></el-option>
						<el-option label="审核中" value="1"></el-option>
						<el-option label="待出款" value="4"></el-option>
						<el-option label="出款失败" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker
					    v-model="rangeDate2"
					    type="daterange"
					    range-separator="至"
					    start-placeholder="审核开始时间"
					    end-placeholder="审核结束时间"
					    value-format="yyyy-MM-dd"
					    @change="pickerChange2"
					></el-date-picker>
					<!-- <el-date-picker type="date" placeholder="审核开始时间" v-model="queryForm.audit_start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
					-
					<el-date-picker type="date" placeholder="审核结束时间" v-model="queryForm.audit_end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker> -->
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px">
				<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" 
					 @click="morePay()">批量出款</el-button>
				<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
					:loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
			</div>
			<el-table @selection-change="handleSelectionChange" :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<!-- <el-table-column header-align="center" align="center"  label="选择"></el-table-column> -->
				<el-table-column :selectable="selectableFun" header-align="center"  align="center"  fixed type="selection" label="ID" min-width="80"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="create_time" label="提现时间"></el-table-column>
				<el-table-column  min-width="150"  header-align="center" align="center" prop="account_name" label="提现发起人"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="mobile" label="销售账号"></el-table-column>
				<el-table-column min-width="100"   header-align="center" align="center" prop="money" label="提现金额(元)">
					<template slot-scope="scope">
						<span style="color:#F56C6C">{{scope.row.money}}</span>
					</template>
				</el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="fee_money" label="提现手续费(元)"></el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="service_fee" label="提现服务费(元)"></el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="true_money" label="提现到账金额(元)"></el-table-column>
				<el-table-column  min-width="140" header-align="center" align="center" prop="account_no" label="到账银行卡"></el-table-column>
				<el-table-column  min-width="100" header-align="center" align="center" prop="bank_name" label="银行卡总行"></el-table-column>
				<el-table-column  min-width="100" header-align="center" align="center" prop="status_text" label="付款状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 4" style="color:#F56C6C">
							{{scope.row.status_text}}
						</span>
						<span v-else>{{scope.row.status_text}}</span>
					</template>
				</el-table-column>
				<el-table-column min-width="150"  header-align="center" align="center" prop="reject_reason" label="驳回原因"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="audit_time" label="审核时间"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="repay_time" label="出款时间"></el-table-column>
				<el-table-column min-width="100"  header-align="center" align="center" fixed="right" label="操作"  >
					<template v-if="scope.row.status == 1" slot-scope="scope">
						<el-button @click="shenClick(scope.row)" type="text" size="small">审核</el-button>
					</template>
					
				</el-table-column>
				
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
		
		<el-dialog width="30%" title="批量审核并出款" :visible.sync="morePayState" class="dialog">
			<span>确定要批量出款已勾选的提现记录吗？</span>
			<div slot="footer" class="dialog-footer">
			    <el-button :loading="downLoading"   type="primary"  @click="chuPayClick">全部通过并出款</el-button>
			    <el-button   @click="morePayState = false">取 消</el-button>
			</div>
		  
		</el-dialog>
		
		<el-dialog width="40%" title="审核并出款" :visible.sync="onePayState" class="dialog">
			<div class='dialogDes'>提现发起人:{{oneShenItem.account_name}}</div>
			<div class='dialogDes'>销售账号：{{oneShenItem.mobile}}</div>
			<div class='dialogDes'>提现金额：{{oneShenItem.money}}</div>
			<div class='dialogDes'>提现手续费：{{oneShenItem.fee_money}}</div>
			<div class='dialogDes'>提现服务费：{{oneShenItem.service_fee}}</div>
			<div class='dialogDes'>到账金额：{{oneShenItem.true_money}}</div>
			<div class='dialogDes'>到账银行卡：{{oneShenItem.account_no}}</div>
			<div class='dialogDes'>银行卡总行：{{oneShenItem.bank_name}}</div>
			<div slot="footer" class="dialog-footer">
			    <el-button :loading="downLoading"   type="primary"  @click="chuPayClick">通过并出款</el-button>
			    <el-button   @click="shibaiState = true">驳 回</el-button>
			</div>
		</el-dialog>
		
		<el-dialog width="40%" title="请填写驳回原因" :visible.sync="shibaiState" class="dialog">
			<el-input
			  clearable
			  type="textarea"
			  :rows="3"
			  placeholder="请输入内容"
			  :maxlength="30"
			  v-model="textarea">
			</el-input>
			<div slot="footer" class="dialog-footer">
			    <el-button  type="primary"  @click="trueBohuiClick">确定</el-button>
			    <el-button   @click="shibaiState = false">取 消</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import paginations from '../../components/pagination/paginations';
	export default {
		name: "teamMoneyShenList",
		data() {
			return {
				queryForm: {
					start_time:'',
					end_time:'',
					audit_start_time:'',
					audit_end_time:'',
					mobile:'',
					account_name:'',
					status:'' //提现时间 1审核中 2出款成功 3出款失败
				},
				stockTable: { //列表
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
				downLoading: false, //导出loading
				morePayState:false,
				onePayState:false,
				shibaiState:false,
				textarea:'',
				oneShenItem:{},
				multipleSelection:[],
				rangeDate: '',
				rangeDate2: '',
			}
		},
		mounted() {
			this.handleDefaultTime();
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize
			})
		},
		components: {
			paginations,
		},
		methods: {
			pickerChange(DateArr) { //时间选择器
			    this.queryForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.queryForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			pickerChange2(DateArr) { //时间选择器
			    this.queryForm.audit_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.queryForm.audit_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			handleDefaultTime() { //默认获取三十天
			    // let date =this.$moment().endOf('day').format('x');
			    // this.queryForm.end_time = this.$moment(Number(date) - 3600 * 1000 * 24 -1).format("YYYY-MM-DD");
			    // this.queryForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD");
			},
			handleSelectionChange(rows){
				this.multipleSelection = rows;
			},
			selectableFun(item,index){
				if (item.status == 1) {
					return true
				}else {
					return false
				}
			},
			// 单调审核
			shenClick(item){
				this.oneShenItem = item
				this.onePayState = true
			},
			trueBohuiClick(){
				
				if (this.textarea.length == 0) {
					this.$message({
					    message: '请输入驳回原因'
					});
					return;
				}
				
				let params = {
					withdraw_ids:this.oneShenItem.id,
					audit_status:'2',
					reject_reason:this.textarea
				}
				
				this.$api.post("sale/withdrawAudit", params, res => {
					if (res.code == 0) {
						this.$message({
						    message: '驳回成功!',
							type:'success'
						});
					}else {
						this.$message({
						    message: res.msg
						});
					}
					this.shibaiState = false
					this.onePayState = false
					this.getPageSize(10);
				})
				
				
			},
			// 出款
			chuPayClick(){
				let params = {
					audit_status:1,
					reject_reason:''
				}
				if (this.onePayState == true) {
					params.withdraw_ids = this.oneShenItem.id
				}else {
					let arr = []
					for (let item of this.multipleSelection) {
						arr.push(item.id)
					}
					params.withdraw_ids = arr.join(',')
				}
				this.downLoading = true;
				this.$api.post("sale/withdrawAudit", params, res => {
					if (res.code == 0) {
						this.$message({
						    message: '出款成功!',
							type:'success'
						});
					}else {
						this.$message({
						    message: res.msg
						});
					}
					this.downLoading = false;
					this.shibaiState = false
					this.onePayState = false
					this.morePayState = false
					this.getPageSize(10);
				})
				
			},
			morePay() {
				if (this.multipleSelection.length == 0) {
					this.$message({
					    message: '请先选择要批量出款的数据!'
					});
					return;
				}else {
					this.morePayState = true
				}
				
			},
			handleDownLoad(params) { //导出
				let reqData = {
					type: 19,
					value: JSON.stringify(params)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("sale/withdrawList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.page.total = data.total; //总数
						this.stockTable.list = data.data;
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.dialogDes {
		height: 30px;
		line-height: 30px;
	}
</style>